import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import api, { formatCurrency, formatDateTime } from "@/lib/api";
import { toast } from "sonner";
import { usePermission } from "@/hooks/usePermission";
import Pagination from "@/components/Pagination";

export default function AdminAnticipations({ anticipations, onRefresh, pagination, onPageChange }) {
  const { canEdit } = usePermission("antecipacoes");
  const simulateWebhook = async (antId, status) => {
    try {
      await api.post(`/webhooks/simulate/${antId}?status=${status}`);
      toast.success(`Webhook simulado: ${status}`);
      onRefresh?.();
    } catch { toast.error("Erro ao simular webhook"); }
  };

  return (
    <>
    <Card className="border-white/5" data-testid="admin-anticipations-table">
      <CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5 hover:bg-transparent">
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Colaborador</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Bruto</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Líquido</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Títulos</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Status</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Data</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-muted-foreground text-right">Simular</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {anticipations.map((a) => (
              <TableRow key={a.id} data-testid={`admin-ant-row-${a.id}`} className="border-white/5 hover:bg-white/[0.02]">
                <TableCell className="font-medium">{a.employee_name}</TableCell>
                <TableCell>{formatCurrency(a.total_bruto)}</TableCell>
                <TableCell className="text-emerald-400 font-medium">{formatCurrency(a.total_liquido)}</TableCell>
                <TableCell>{a.titulo_count}</TableCell>
                <TableCell><StatusBadge status={a.status} /></TableCell>
                <TableCell className="text-muted-foreground text-sm">{formatDateTime(a.created_at)}</TableCell>
                <TableCell className="text-right">
                  {a.status === "aguardando_pagamento" && canEdit && (
                    <div className="flex gap-1 justify-end">
                      <Button size="sm" variant="ghost" data-testid={`simulate-liquidado-${a.id}`}
                        onClick={() => simulateWebhook(a.id, "liquidado")}
                        className="text-emerald-400 hover:bg-emerald-500/10 text-xs h-7 px-2">Liquidar</Button>
                      <Button size="sm" variant="ghost" data-testid={`simulate-recusado-${a.id}`}
                        onClick={() => simulateWebhook(a.id, "recusado")}
                        className="text-red-400 hover:bg-red-500/10 text-xs h-7 px-2">Recusar</Button>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
    {pagination && <Pagination page={pagination.page} totalPages={pagination.total_pages}
      total={pagination.total} pageSize={pagination.page_size} onPageChange={onPageChange} />}
  </>
  );
}
